
import Vue from "vue";
import { StoreTypes, cookieTypes } from "@/assets/js/Types";
import AIAskCom from "../ShareComponents/AIAskCom.vue";
import DeviceRequestBill from "@/assets/js/Bill/DeviceRequestBill";
import LightLogCom from "../ShareComponents/LightLogCom.vue";
import pageCom from "@/components/PageCom.vue";
import { deviceInfoByAi } from "@/assets/js/Types";
import CookieUtil from "@/assets/js/CookieUtil";
export default Vue.extend({
  components: { pageCom, LightLogCom, AIAskCom },
  data() {
    return {
      onlineState: 2,
      items: [] as any,
      search: null as any,
      currentPage: 1,
      pageSize: 6,
      total: 0,
      image: require("@/assets/img/icon/deepseek.png"),
      choosedItem: [] as string[],
      timer: null as any,
    };
  },
  async mounted() {
    await this.getLights();
    await this.getLightAuto();
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async getLightAuto() {
      const projectsid = CookieUtil.getCookie(cookieTypes.XC_COOKIES_PROJECTSID);
      if (projectsid == "2025122915542861860300727b8a5f399") {
        this.timer = window.setInterval(() => {
          DeviceRequestBill.GetLightCtrs(null, 1, 100, undefined, true).then(
            (data: any) => {
              if (this.items && this.items.length > 0) {
                this.items.forEach((ele: any) => {
                  const items = data.data;
                  if (items && items.length >= 0) {
                    items.forEach((it: any) => {
                      if (it.sid == ele.sid) {
                        ele.light = it.light;
                        ele.voltage = it.voltage;
                        ele.current = it.current;
                        ele.power = it.power;
                      }
                    });
                  }
                });
              }
            }
          );
        }, 1000);
      }
    },
    async getLights() {
      const obj = {
        searchStr: this.search,
        online: this.onlineState,
      };
      const ret = await DeviceRequestBill.GetLightCtrs(
        obj,
        this.currentPage,
        this.pageSize
      );
      this.total = ret.total;
      this.items = ret.data;
    },
    async searchClick() {
      await this.getLights();
    },
    deviceSidClick(sid: string) {
      const dialog: any = this.$refs.lightLogDialog;
      const exsit: any = this.items.find((x: any) => x.sid == sid);
      if (exsit) {
        if (dialog) {
          dialog.show(sid, exsit.deviceTypeSid, exsit.ctrlAddr);
        }
      }
    },
    change(val: number, size: number) {
      this.currentPage = val;
      this.pageSize = size;
      this.getLights();
    },
    handleSelectionChange(val: any) {
      this.choosedItem = [];
      val.forEach((x: any) => {
        this.choosedItem.push(x.ctrlAddr);
      });
    },
    aiDevice(obj: any) {
      console.log(obj);
      const current: deviceInfoByAi = {
        电压: obj.voltage + "v",
        电流: obj.current + "A",
        功率因素: obj.powerFactory,
        亮度: obj.light,
        在线状态: obj.online == 0 ? "离线" : "在线",
        设备序号: obj.ctrlAddr,
        功率: obj.power,
        信号强度: obj.signal + "dBm",
      };
      const projectInfo = this.$store.state.project[StoreTypes.XC_PROJECT_CURRENT];
      const msg = `这是一个智能路灯控制器，
      安装在经度${projectInfo.lng},纬度${projectInfo.lat},
      现在的时间是${new Date().toDateString()},在路灯合理的关灯时间内控制器离线是合理的。
      这个控制器当前的状态是${obj.online == 0 ? "离线" : "在线"}状态，
      这个控制器的最新上报日志记录如下：${JSON.stringify(current)},
      请分析一下这个设备运行状态。`;
      const dialog: any = this.$refs.aiDialog;
      dialog.open(msg);
    },
    getData() {
      return this.choosedItem;
    },
  },
});
